import { __awaiter, __generator } from "tslib";
import { fetchManySubEntities } from './http/fetch-many-sub-entitities';
import { SubEntityType } from './models/sub-entity-type';
export var fetchFamiliesFeatures = function (familyIds, includeType) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchManySubEntities(familyIds, SubEntityType.Features, "f" /* Family */, includeType)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
